import React from 'react';
import "../styles/Header.css"
import icon from "../images/icon_ugc.png"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Link, Element } from "react-scroll";




const Header = () => {
  return (
    <header className="header">
      <div className="header-left">
      <Link to="/">
        <img src={icon} alt="Icon" className="header-icon"  width={100} height={100}/>
         </Link>
        <h1 className="header-title">UGC Creator</h1>
      </div>
      <div className="header-right">
        <Link to="faq-section" smooth={true} duration={500} className="header-subtitle">FAQs</Link>
        <Link to="contract-section" smooth={true} duration={500} className="header-subtitle">Contact</Link>
      </div>
    </header>
  );
};

export default Header;  // Header bileşenini dışarıya aktarıyoruz
